// Module
var code = "<div class=\"input-group\"> <input type=\"text\" class=\"form-control\" value=\"{{ vm.calculatedValue }}\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\" readonly=\"readonly\"> </div> ";
// Exports
module.exports = code;